import { ref } from 'vue';
import { isGuestLoginName } from '@/features/profile/oro-mx-profile-edit';

/** 底栏再次点「我的」且个人页仍挂着时递增，用来重新打开绑定弹窗。 */
export const guestBindPromptTick = ref(0);

export function requestGuestBindPrompt() {
  guestBindPromptTick.value += 1;
}

export function shouldShowGuestBind(input: {
  authenticated: boolean;
  dismissed: boolean;
  loginName?: string | null;
  phone?: string | null;
}) {
  return input.authenticated
    && !input.dismissed
    && isGuestLoginName(input.loginName)
    && !(input.phone ?? '').trim();
}
